// Raw probe console — fire hand-crafted REST calls at the project backends,
// with or without the current ID token. This is the actual testing surface.
import { firebaseConfig } from "./firebase.js";

const out = () => document.getElementById("probe-out");
const log = (label, obj) => {
  out().textContent =
    `[${label}] ${new Date().toISOString()}\n` +
    (typeof obj === "string" ? obj : JSON.stringify(obj, null, 2)) +
    "\n\n" + out().textContent;
};

export function installProbe({ auth }) {
  document.getElementById("btn-dump-token").onclick = async () => {
    const u = auth.currentUser;
    if (!u) return log("token", "not signed in");
    const t = await u.getIdToken();
    log("ID token (paste into Repeater)", t);
    // also expose helpers on window for console-driven testing
  };

  // window.probe.* — call from DevTools console during testing
  window.probe = {
    config: firebaseConfig,
    token: async () => (auth.currentUser ? auth.currentUser.getIdToken() : null),

    // Firestore REST: GET a document by full path, optionally as another project/user
    firestoreGet: async (path, { token, projectId } = {}) => {
      const pid = projectId || firebaseConfig.projectId;
      const tok = token === undefined ? await window.probe.token() : token;
      const r = await fetch(
        `https://firestore.googleapis.com/v1/projects/${pid}/databases/(default)/documents/${path}`,
        { headers: tok ? { Authorization: `Bearer ${tok}` } : {} }
      );
      const body = await r.text();
      log(`firestoreGet ${pid}/${path} (${r.status})`, body);
      return { status: r.status, body };
    },

    // Firestore REST: run a structured query at a parent path
    firestoreQuery: async (parent, structuredQuery, { token, projectId } = {}) => {
      const pid = projectId || firebaseConfig.projectId;
      const tok = token === undefined ? await window.probe.token() : token;
      const r = await fetch(
        `https://firestore.googleapis.com/v1/projects/${pid}/databases/(default)/documents/${parent}:runQuery`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(tok ? { Authorization: `Bearer ${tok}` } : {}),
          },
          body: JSON.stringify({ structuredQuery }),
        }
      );
      const body = await r.text();
      log(`firestoreQuery ${pid}/${parent} (${r.status})`, body);
      return { status: r.status, body };
    },

    // RTDB REST
    rtdbGet: async (path, { token, dbUrl } = {}) => {
      const base = dbUrl || firebaseConfig.databaseURL;
      const tok = token === undefined ? await window.probe.token() : token;
      const url = `${base}/${path}.json` + (tok ? `?auth=${encodeURIComponent(tok)}` : "");
      const r = await fetch(url);
      const body = await r.text();
      log(`rtdbGet ${base}/${path} (${r.status})`, body);
      return { status: r.status, body };
    },

    // identitytoolkit: accounts:lookup (email/uid enumeration probe)
    accountsLookup: async (idToken) => {
      const r = await fetch(
        `https://identitytoolkit.googleapis.com/v1/accounts:lookup?key=${firebaseConfig.apiKey}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ idToken: idToken || (await window.probe.token()) }),
        }
      );
      const body = await r.text();
      log(`accountsLookup (${r.status})`, body);
      return { status: r.status, body };
    },

    // identitytoolkit: createAuthUri (email existence oracle)
    createAuthUri: async (email) => {
      const r = await fetch(
        `https://identitytoolkit.googleapis.com/v1/accounts:createAuthUri?key=${firebaseConfig.apiKey}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ identifier: email, continueUri: "http://localhost" }),
        }
      );
      const body = await r.text();
      log(`createAuthUri ${email} (${r.status})`, body);
      return { status: r.status, body };
    },
  };

  log("probe ready", "window.probe.* available — see src/probe.js");
}
